import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import AddTaskFormDialog from "./AddTaskFormDialog";
import { useAddContactTaskMutation } from "src/services/ContactServices";
import { showToast } from "src/utils/showToaster";
import { useParams } from "react-router-dom";
import { useGetUserQuery } from "src/services/UserServices";

type Props = {
  onClose: () => void;
};

export type addContactTaskValuesType = {
  taskName: string;
  activityDate: any;
  activityTime: any;
  taskType: string;
  priority: string;
  queue: any;
  assignedTo: string;
  description: any;
  wantToAddReminder:string ;
  reminderForDate:any 
};

const AddTaskFormDialogWrapper = ({ onClose }: Props) => { 
  const { contactId } = useParams();
  const [addContactTask] = useAddContactTaskMutation();

  const { data} = useGetUserQuery({
    limit: 10,
    searchValue: '',
    params: ["firstName", "lastName", "mobile", "email"],
    page: 1,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

  const userOptions = data?.data?.map((el:any)=>{
    return{
      label:el?.userName ,
      value :el?._id
    }
  })

  // Form Initial Values
  const initialValues: addContactTaskValuesType = {
    taskName: "",
    activityDate: null,
    activityTime: null,
    taskType: "",
    priority: "",
    queue: [],
    assignedTo: "",
    description: "",
    wantToAddReminder :'',
    reminderForDate :null
  };


  // Handle Submit
  const handleSubmit = (
    values: addContactTaskValuesType,
    { setSubmitting, resetForm }: FormikHelpers<addContactTaskValuesType>
  ) => {
    const formatedValues = {
      contactId: contactId,
      taskName: values?.taskName,
      activityDate: values?.activityDate,
      priority: values?.priority,
      taskAction : values?.taskType,
      assignedToId: values?.assignedTo,
      description: values?.description,
      wantToAddReminder: values?.wantToAddReminder === 'No reminder' ? false : true,
      reminderOn : values?.wantToAddReminder ,
      reminderForDate: values?.reminderForDate || '' ,
      queueName:values?.queue
    };

    addContactTask(formatedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <AddTaskFormDialog userOptions={userOptions} formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddTaskFormDialogWrapper;
